// Fix for saveTransform.js: flatten tiered formData.skills if transform.skills is not already flat

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const tierMap = {
    static: 0,
    basic: 1,
    advanced: 2,
    expert: 3,
    master: 4,
    grandmaster: 5,
    mythic: 6
};

export async function saveTransform(transform, token) {
    const headers = { Authorization: `Bearer ${token}` };

    let skillsPayload = [];
    if (Array.isArray(transform.skills)) {
        skillsPayload = transform.skills.map(skill => ({
            skillId: skill.skillId,
            name: skill.name,
            notes: skill.notes || '',
            tier: skill.tier,
            isPassive: !!skill.isPassive,
            isDefaultUnlocked: !!skill.isDefaultUnlocked
        }));
    } else {
        // fallback: flatten formData.skills by tier
        for (const [tier, tierSkills] of Object.entries(transform.skills || {})) {
            const tierIndex = tierMap[tier];
            if (tierIndex === undefined) continue;
            for (const skill of tierSkills) {
                if (!skill.name?.trim()) continue;
                skillsPayload.push({
                    name: skill.name.trim(),
                    notes: skill.notes?.trim() || '',
                    tier: tierIndex,
                    isDefaultUnlocked: !!skill.isDefaultUnlocked,
                    isPassive: !!skill.isPassive
                });
            }
        }
    }

    const payload = {
        name: transform.name,
        description: transform.description,
        skills: skillsPayload
    };

    if (transform.transformId) {
        await axios.put(`${API_BASE_URL}/transforms/${transform.transformId}`, payload, { headers });
        return transform.transformId;
    } else {
        const res = await axios.post(`${API_BASE_URL}/transforms`, payload, { headers });
        return res.data.transformId;
    }
}